import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, InPageAlert } from '@snsw/react-component-library';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { PagePath } from 'shared/constants/pagePath';
import styles from './ResumeApplication.module.scss';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';

export const InvalidApplicationError = (props) => {
  const navigate = useNavigate();

  const redirectToLandingPage = () => {
    switch (props.licenceType) {
      case PlantItemConstants.licenceType:
        window.location.replace(PlantItemConstants.snswLandingPageUrl);
        break;
      case PlantDesignConstants.licenceType:
        navigate(PagePath.plantDesignBeforeYouStart);
        break;
      default:
        window.location.replace(PlantItemConstants.snswLandingPageUrl);
    }
  };

  return (
    <>
      <InPageAlert
        variant="error"
        headingLevel="h2"
        title="Your application has expired."
        className={styles.expiryAlert}
      >
        You will need to start a new application.
      </InPageAlert>
      <Button theme="primary" onClick={redirectToLandingPage}>
        Start application
      </Button>
    </>
  );
};
